// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3qHMh","head":"ProcedureTableInfo_head__AaIEk"};